import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { Dispatch, SetStateAction } from 'react'

import { calcSobFyByQuarters, IFinSobItem } from '../../helpers/calcSobFyByQuarters'
import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { IS_CALC_FY_SOB_BY_ALL_FQ, PLANNING_BY_FY_FQ } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'
import { setItemValuesUniversal } from './setItemValuesUniversal'

/**
 * Calculate and set FY SoB by quarters SoB and Values
 */
export const setFySobByQuarters = (
  items: IJBPPlanningItem[],
  setting: IFormActualsTargetsSettings,
  fieldProps: IFieldProps,
  fy: number,
  type: 'actuals' | 'targets',
  setActualsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>,
  setTargetsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>,
  currentFYear: number,
  currentFQuarter: number,
  translationFactors?: ITranslationFactors[] | null
) => {
  const data = [...items]

  const curFieldName = getFieldName({ ...fieldProps, isSoB: false })
  const sobFieldName = getFieldName(fieldProps)
  const cat = setting.Category
  const isActuals = type === 'actuals'

  // Filtered on Top level: PartnerId, ProgramTypes, Category, IsActuals, IsTarget, IsQuota
  const fyData = items.filter(
    (el) =>
      el.ProgramTypes === setting.ProgramType &&
      el.Category === setting.Category &&
      el.SubCategory === setting.SubCategory &&
      el.L3Category === setting.L3Category &&
      el.FYear === fy &&
      el.FQuarter === PLANNING_BY_FY_FQ
  )

  if (fyData.length >= 1) {
    const finSobItems: IFinSobItem[] = []

    const isUseToDateQuarter = fy === currentFYear && isActuals
    const lastQuarter =
      isUseToDateQuarter && !IS_CALC_FY_SOB_BY_ALL_FQ ? currentFQuarter + 1 : PLANNING_BY_FY_FQ
    for (let fq = 1; fq < lastQuarter; fq++) {
      const qData = items.filter(
        (el) =>
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (qData.length >= 1) {
        const val = Number(qData[0][curFieldName] || 0)
        const sob = Number(qData[0][sobFieldName] || 0)
        finSobItems.push({ value: val, sob: sob })
      }
    }

    const newFYSob = calcSobFyByQuarters(finSobItems, isActuals)
    const newItem = setItemValuesUniversal(
      fyData[0],
      newFYSob,
      fieldProps,
      cat,
      false,
      translationFactors
    )

    const idx = items.indexOf(fyData[0])
    data.splice(idx, 1, newItem)

    if (isActuals) {
      setActualsItems([...data])
    } else {
      setTargetsItems([...data])
    }
  }

  return data
}
